export const GET_CHARGEBACK_MONITORING_LIST = "/ChargebackTransaction/GetChargebackTransactionSearchByUserName"
export const GET_CHARGEBACK_MONITORING_SEARCH = "/ChargebackTransaction/GetChargebackTransactionSearchByUserName"